import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../assets/css/styles.css';
const axios = require('axios').default;
var config = require('../../config/config.json');


export default function AlumniDashboard(props) {
  document.title = props.title;
  var retrievedUserDetailsObject = JSON.parse(localStorage.getItem('userAlumniDetailsLog'));


  const [userLoginDetails, setLoginDetailsValue] = useState(retrievedUserDetailsObject);

  const [userName, setUserName] = useState("");
  const [userYearOfPassingOut, setUserYearOfPassingOut] = useState("");
  const [userDepartment, setUserDepartment] = useState("");
  const [userWhichCourse, setUserWhichCourse] = useState("");
  const [userFurtherStudiesIfAny, setUserFurtherStudiesIfAny] = useState("");
  const [userCurrentOccupation, setUserCurrentOccupation] = useState("");
  const [userContactAddress, setUserContactAddress] = useState("");
  const [userMemberOfTheAlumniAssociation, setUserMemberOfTheAlumniAssociation] = useState("");
  const [submittedFeedbackDetails, setSubmittedFeedbackDetails] = useState("");

  console.log('userAlumniDetailsLog: ', userLoginDetails);
  const navigate = useNavigate();

  useEffect(() => {
    getAlumniPersonalDetails();
  }, []);

  function onTakeUpSurveyClick() {
    if (userName) {
      if (userYearOfPassingOut) {
        if (userDepartment) {
          if (userWhichCourse) {
            if (userCurrentOccupation) {
              if (userMemberOfTheAlumniAssociation) {
                axios.post(config.API_URL + 'updateAlumniPersonalDetails', {
                  inputUserId: userLoginDetails.alr_auto_id,
                  inputEmailId: userLoginDetails.alr_email_id,
                  inputName: userName,
                  inputYearofPassout: userYearOfPassingOut,
                  inputDepartment: userDepartment,
                  inputCompletedCourse: userWhichCourse,
                  inputFurtherStudies: userFurtherStudiesIfAny,
                  inputCurrentOccupation: userCurrentOccupation,
                  inputAddress: userContactAddress,
                  inputIsMember: userMemberOfTheAlumniAssociation,
                }, {
                  headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
                }).then(function (response) {
                  if (response.data.status.status == 1) {
                    userLoginDetails['userName'] = userName;
                    localStorage.setItem('userAlumniDetailsLog', JSON.stringify(userLoginDetails));
                    navigate('/AlumniFeedback');
                  }
                }).catch(function (error) {
                  toast.error(error);
                });
              } else {
                toast.error("Please Select Are you a member of the alumni association of college?");
              }
            } else {
              toast.error("Please Enter Current Occupation");
            }
          } else {
            toast.error("Please Select Which course you have done in college?");
          }
        } else {
          toast.error("Please Select Department");
        }
      } else {
        toast.error("Please Select Year of Passing out");
      }
    } else {
      toast.error("Enter Name");
    }

  }

  function getAlumniPersonalDetails() {
    axios.post(config.API_URL + 'getAlumniPersonalDetails', {
      inputUserId: userLoginDetails.alr_auto_id
    }, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
    }).then(function (response) {
      console.log('getAlumniPersonalDetails', response.data.data);
      if (response.data.status.status == 1) {
        setUserName(response.data.data[0].alr_name);
        setUserYearOfPassingOut(response.data.data[0].alr_year_of_passout);
        setUserDepartment(response.data.data[0].alr_department);
        setUserWhichCourse(response.data.data[0].alr_completed_course_name);
        setUserFurtherStudiesIfAny(response.data.data[0].alr_further_studies);
        setUserCurrentOccupation(response.data.data[0].alr_current_occupation);
        setUserContactAddress(response.data.data[0].alr_contact_address);
        setUserMemberOfTheAlumniAssociation(response.data.data[0].alr_is_member_alumni_association);
        setSubmittedFeedbackDetails(response.data.data[0].alr_feedback_submitted_bit);
      }
    }).catch(function (error) {
      toast.error(error);
    });
  }

  function clickOnLogOut() {
    localStorage.removeItem("userDetailsLog");
    localStorage.removeItem("isAuthenticated");
    localStorage.clear();
    navigate('/Alumni');
  }

  const LogoURL = require(`../../assets/images/${config.logoUrl}`).default;
  return (
    <div className="index-cover">
      <div className="container main-container">
        <section className='section-header' >
          <div className='row'><div className="col-md-12" >
            <div className='logout-strip'>
              <div className='link-holder'>
                <a className="btn-link" type="button">Welcome {userName}</a>
                <span className='line-divider'></span>
                <a className="btn-link" type="button" onClick={clickOnLogOut}>Logout</a>
              </div>
            </div>
            <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
            <div className='feedback-title' >Feedback on Academic Performance and Ambiance</div>
          </div>
          </div>
        </section>

        <section className='section-userInformation'>
          <div className='row'>
            <div className='col-md-12'>
              <div className='note note-thankyou'>
                <span style={{ display: 'block', marginBottom: '10px' }}>Dear {userName},  </span>Thank you for selecting {config.collegeName} as the institute for your higher education. You are an integral part of the {config.collegeName} family. We are carrying out a survey to receive feedback from Alumni.</div>
            </div>
          </div>
          <div className='row'>

            <div className="form-group col-md-6">
              <label htmlFor="exampleInputName">Enter Name <em>*</em></label>
              <input type="text" className="form-control" id="exampleInputName" defaultValue={userName} placeholder="Enter Name" onChange={(e) => setUserName(e.target.value)} />
            </div>

            {/* <div className="form-group col-md-6">
              <label htmlFor="name">Email address <em>*</em></label>
              <input type="text" className="form-control" id="exampleInputEmail1" placeholder="Enter Email address" defaultValue={userLoginDetails.alr_email_id} disabled />
            </div> */}


            <div className="form-group  col-md-6">
              <label htmlFor="">Select Year of Passing out <em>*</em></label>
              <select name="appointment" className="form-control" value={userYearOfPassingOut} onChange={(e) => setUserYearOfPassingOut(e.target.value)}>
                <option value="">-- Select--</option>
                <option value="2024-2025">2024-2025</option>
                <option value="2023-2024">2023-2024</option>
                <option value="2022-2023">2022-2023</option>
                <option value="2021-2022">2021-2022</option>
                <option value="2020-2021">2020-2021</option>
                <option value="2019-2020">2019-2020</option>
                <option value="2017-2018">2017-2018</option>
                <option value="2018-2019">2018-2019</option>
                <option value="2016-2017">2016-2017</option>
                <option value="2015-2016">2015-2016</option>
                <option value="2014-2015">2014-2015</option>
                <option value="2013-2014">2013-2014</option>
                <option value="2012-2013">2012-2013</option>
                <option value="2011-2012">2011-2012</option>
                <option value="2010-2011">2010-2011</option>
                <option value="2009-2010">2009-2010</option>
              </select>
            </div>

            <div className="form-group  col-md-6">
              <label htmlFor="">Select Department <em>*</em></label>
              <select name="appointment" className="form-control" value={userDepartment} onChange={(e) => setUserDepartment(e.target.value)}>
                <option value="" selected>-- Select--</option>
                <option value="Department of Education ">Department of Education </option>
                <option value="Humanities">Humanities</option>
                <option value="Commerce">Commerce</option>
                <option value="Science">Science</option>
                <option value="Other">Other</option>
              </select>
            </div>

            <div className="form-group  col-md-6">
              <label htmlFor="">Which course you have done in college? <em>*</em></label>
              <select name="appointment" className="form-control" value={userWhichCourse} onChange={(e) => setUserWhichCourse(e.target.value)}>
                <option value="">-- Select--</option>
                <option value="B.A. English">B.A. English</option>
                <option value="B.A. Hindi">B.A. Hindi</option>
                <option value="B.A. Marathi">B.A. Marathi</option>
                <option value="B.A. Geography">B.A.Geography</option>
                <option value="B.A. History">B.A.History</option>
                <option value="B.A. Economics">B.A.Economics</option>
                <option value="Political Science(General Course)">Political Science(General Course)</option>
                <option value="Psychology(General Course)">Psychology(General Course)</option>
                <option value="Sociology(General Course)">Sociology(General Course)</option>
                <option value="B.Sc. Chemistry">B.Sc. Chemistry</option>
                <option value="B.Sc. Zoology">B.Sc.Zoology</option>
                <option value="B.Sc. Physics">B.Sc. Physics</option>
                <option value="B.Sc. Maths">B.Sc. Maths</option>
                <option value="B.Sc. Botany">B.Sc. Botany</option>
                <option value="B.Com. (Specialization in Marketing and Costing)">B.Com. (Specialization in Marketing and Costing)</option>
                <option value="B.B.A. (Computer Application)">B.B.A. (Computer Application)</option>
                <option value="M. Sc. Organic Chemistry">M. Sc. Organic Chemistry</option>
                <option value="M.A. Hindi">M.A. Hindi</option>
                <option value="M.A. English">M.A. English</option>
                <option value="M.A. Marathi">M.A. Marathi</option>
                <option value="M.Com.">M.Com.</option>
                <option value="Research Centre in Organic Chemistry">Research Centre in Organic Chemistry</option>
                <option value="Physical Education(Course)">Physical Education(Course)</option>
                <option value="Environmental Science(Course)">Environmental Science(Course)</option>
              </select>
            </div>

            <div className="form-group col-md-6">
              <label htmlFor="years">Further Studies if any after RKMM (Degree and Institute)</label>
              <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" onChange={(e) => setUserFurtherStudiesIfAny(e.target.value)} defaultValue={userFurtherStudiesIfAny} placeholder="Further Studies if any after RKMM (Degree and Institute) " />
            </div>

            <div className="form-group col-md-6">
              <label htmlFor="years">Current Occupation (Designation and Organization) <em>*</em></label>
              <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" onChange={(e) => setUserCurrentOccupation(e.target.value)} defaultValue={userCurrentOccupation} placeholder="Current Occupation (Designation and Organization)" />
            </div>

            <div className="form-group col-md-6">
              <label htmlFor="years">Contact Address</label>
              <input type="text" className="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" onChange={(e) => setUserContactAddress(e.target.value)} defaultValue={userContactAddress} placeholder="Contact Address" />
            </div>

            <div class="form-group col-md-6">
              <label for="">Are you a member of the alumni association of college?<em>*</em> </label>
              <select name="appointment" className="form-control" value={userMemberOfTheAlumniAssociation} onChange={(e) => setUserMemberOfTheAlumniAssociation(e.target.value)}>
                <option value="">-- Select--</option>
                <option value="Yes">Yes </option>
                <option value="No">No </option>
              </select>
            </div>

          </div>

          <div className='row'>
            <div className='row-feedbackbox' style={{borderTop: 'none'}}>
              {
                submittedFeedbackDetails == '0' ?
                  // <div className="col-md-4">
                  //   <div className='box-feedback' >
                  //     <span className='number'>1</span><h4>Alumni Feedback  </h4>
                  //     <button className='btn btn-primary' onClick={onTakeUpSurveyClick}>Take up Survey</button>
                  //   </div>
                  // </div>
                  <div class="col-md-12">
                    <button type="button" onClick={onTakeUpSurveyClick} className="btn btn-primary btn-startSurvey btn-block" >Take up Survey</button>
                  </div>
                  :
                  <div className="col-md-4">
                    <div className="box-feedback submitted">
                      <span className='status'>Submitted</span>
                      {/* <h4> Alumni Feedback</h4> */}
                      <button className="btn btn-primary btn-block">Submitted</button>
                    </div>
                  </div>
              }
            </div>
          </div>
        </section>
        <section className='section-footer'>
          <div className='row'><div className='col-md-12'><div className='footer col-md-6'>{config.collegeName}, Feedback System {config.version}</div>
            <div className='footer col-md-6' style={{ textAlign: 'right' }}>{config.PoweredBy}</div>
          </div></div>
        </section>
      </div>
      <ToastContainer />
    </div>
  )
}